/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: QuarterlyOrdersListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: QuarterlyOrdersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { QuarterlyOrdersData, QuarterlyOrdersService } from './QuarterlyOrders.service';
import { QuarterlyOrdersSearchComponent }  from './QuarterlyOrdersSearch.component';

@Component({
	selector: 'my-QuarterlyOrders',
	template: require('./QuarterlyOrdersList.component.html'),
	providers: [QuarterlyOrdersService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class QuarterlyOrdersListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	QuarterlyOrdersList: QuarterlyOrdersData[];
	newQuarterlyOrders: QuarterlyOrdersData;
	selectedQuarterlyOrders: QuarterlyOrdersData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(QuarterlyOrdersSearchComponent) filterComponent: QuarterlyOrdersSearchComponent;

	sortExpression: string = "CustomerID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private QuarterlyOrdersService: QuarterlyOrdersService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newQuarterlyOrders = new QuarterlyOrdersData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.QuarterlyOrdersService.getAll().subscribe(record => this.QuarterlyOrdersList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getQuarterlyOrdersByPaging();

		/*
		this.QuarterlyOrdersList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getQuarterlyOrders() {
		this.QuarterlyOrdersService.getAll()
			.subscribe(data => this.QuarterlyOrdersList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on QuarterlyOrdersSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getQuarterlyOrdersByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getQuarterlyOrdersByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getQuarterlyOrdersByPaging();
	}
	
	// Get records by paging
	getQuarterlyOrdersByPaging() {
		this.QuarterlyOrdersService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.QuarterlyOrdersList=data.QuarterlyOrdersList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addQuarterlyOrders() {
		this.QuarterlyOrdersService.addQuarterlyOrdersData(this.newQuarterlyOrders).subscribe(record => console.log(record));
		this.getQuarterlyOrders();
	}
  
	// Updates existing record
	updateQuarterlyOrders() {
		this.QuarterlyOrdersService.updateQuarterlyOrdersData(this.selectedQuarterlyOrders).subscribe(record => console.log(record));
		this.getQuarterlyOrders();
	}

	// Deletes record with specified id
	deleteQuarterlyOrders(id: string) {
		if (window.confirm('Are you sure you want to delete this QuarterlyOrders?') == true)
		{
			this.QuarterlyOrdersService.deleteQuarterlyOrders(id)
			.subscribe(data => this.getQuarterlyOrders(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getQuarterlyOrdersByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getQuarterlyOrdersByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getQuarterlyOrdersByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getQuarterlyOrdersByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: QuarterlyOrdersData) {
		this.router.navigate(['/QuarterlyOrders', item.CustomerID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: QuarterlyOrdersData) {
		this.router.navigate(['/QuarterlyOrders/Details', item.CustomerID]);
	}

	// Set record as selected
	SelectQuarterlyOrders(item: QuarterlyOrdersData) {
		this.selectedQuarterlyOrders = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: QuarterlyOrdersData) {
		return item.CustomerID === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/QuarterlyOrders/QuarterlyOrdersList.component.ts